import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./dashboard/reducer";

// Statistic
import StatisticReducer from "./statistic/reducer";

// Operator
import OperatorReducer from "./operator/reducer";

// User
import UserReducer from "./user/reducer";

// Company
import CompanyReducer from "./company/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";

// User Admin
import AdminReducer from "./admin/reducer";
import AuditionReducer from "./audition/reducer";
import FieldsReducer from "./fields/reducer";
import ApplicationReducer from "./application/reducer";

// Push Notification
import Notification from "./notification/reducer";

// Location Log
import EventLogReducer, { EventLogNewReducer } from "./eventLog/reducer";

// Log
import LogReducer from "./logging/reducer";

import InquiryListReducer from "./inquiry-list/reducer";
import CategoryReducer from "./category/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  Statistic: StatisticReducer,
  User: UserReducer,
  Company: CompanyReducer,
  Operator: OperatorReducer,

  Role: RoleReducer,
  Global: GlobalReducer,
  Admin: AdminReducer,

  Notification: Notification,

  EventLog: EventLogReducer,
  EventLogNew: EventLogNewReducer,

  Log: LogReducer,
  Audition: AuditionReducer,
  Fields: FieldsReducer,
  Application: ApplicationReducer,

  InquiryList: InquiryListReducer,
  Category: CategoryReducer,
});

export default rootReducer;
